module.exports = __webpack_public_path__ + "img/presscoins-add-coin-dark.bf66eaf3.png";